export default __webpack_public_path__ + "static/media/no.a2946018.svg";